/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/Edit/Content/SaveAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageEditorUpdatedValueData = fromData.useDataValue({ viewPath,
context: 'image',
path: 'editor_updated',
})
let imageOriginalImageValueData = fromData.useDataValue({ viewPath,
context: 'image',
path: 'original_image',
})
let aggregateData = fromAggregate.any(imageEditorUpdatedValueData, imageOriginalImageValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}